import type { CompetitionStageDetailed } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

function getCompetitionStageDetails(competitionId: string, stageId: string): Promise<CompetitionStageDetailed> {
  return requestApiJsonOrThrow<CompetitionStageDetailed>(
    `admin/competitions/${competitionId}/competition-stages/${stageId}`
  )
}

export const competitionStageDetailsQuery = (competitionId: string, stageId: string) => ({
  queryKey: ['competition', competitionId, 'stage', stageId],
  queryFn: () => getCompetitionStageDetails(competitionId, stageId),
})
